<ion-button *ngFor="let item of values" (click)="select(item)" expand="block" [translate]="item.Name"></ion-button>
